<template>
    <div>
        <spinner v-if="cargando"/>
        <div v-else >
            <div>
                <img :src="logo" :alt="clase+' '+modelo.dt1" :class="clase" class="img-fluid animated zoomIn" />
                <div class="text-justify text-justify-p">
                    <div v-html="modelo.dt2"></div>
                </div>
            </div>
            <div class="row p-3">
                <label class="kt-checkbox kt-checkbox--solid kt-checkbox--brand" v-b-modal="'modal-terminos'" for="terminos">
                    <input type="checkbox" v-model="formulario.terminos" :disabled="!formulario.terminos" id="terminos" > Términos y condiciones
                    <span></span>
                </label>
            </div>
            <div class="pt-5 d-flex justify-content-between">
                <button type="button" class="btn btn-secondary btn-font-sm" v-on:click="atras"><i class="flaticon2-back"></i> Regresar</button>
                <button type="button" class="btn btn-primary btn-font-sm" v-on:click="siguiente"> Continuar <i class="flaticon2-next"></i></button>
            </div>
        </div>
        <b-modal id="modal-terminos" title="Términos y condiciones" centered hide-footer>
            <p class="my-4 text-justify" >
                Se reserva el derecho de hacer cambios en cualquier momento sin previo aviso u obligación a la información contenida en este sitio de web, precios, programas de incentivos, especificaciones técnicas, equipamiento, ilustraciones y de modificar o suspender modelos y otros. Las imágenes y videos pueden no corresponder con el producto final. Algunas características del vehículo de la imagen no aplican a los modelos ensamblados o comercializados en Ecuador. Paquete de accesorios es ofrecido por cada concesionario por lo que valor, especificación y Disponibilidad pueden variar. Precios incluyen IVA
            </p>
            <div class="kt-radio-inline text-center">
                <label class="kt-radio">
                    <input type="radio" :value="true" v-model="formulario.terminos" v-on:click="ocultar" id="acepto"/> Acepto
                    <span></span>
                </label>
                <label class="kt-radio">
                    <input type="radio" :value="false" v-model="formulario.terminos" id="rechazo"/> Rechazo
                    <span></span>
                </label>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import spinner from "./spinner-especificaciones";
    import constantes from "../../../constantes";
    export default {
        name: "especificaciones",
        data:()=>({
            logo:null,
            version:{},
            formulario:{
                terminos:false,
            },
            clase:'logo-version',
        }),
        props:['cargando','modelo'],
        components:{
            spinner
        },
        watch:{
            cargando:function(valor){
                if(!valor)
                    this.generarLogo();
            }
        },
        methods:{
            atras:function(){
                this.$router.push({ name: 'p1'});
            },
            generarLogo:function(){
                if(!constantes.funciones.isEmpty(this.$store.getters.getPasos[2]))
                    this.version=this.$store.getters.getPasos[2].version;
                this.logo=this.version.dt10 ? process.env.VUE_APP_URL_API+this.version.dt10 : process.env.VUE_APP_URL_API+this.modelo.dt5;
                this.clase=this.version.dt10 ? 'logo-version' : 'logo-modelo';
            },
            ocultar:function(){
                this.$root.$emit('bv::hide::modal', 'modal-terminos', '#modal-terminos');
            },
            siguiente:function(){
                if(this.formulario.terminos){
                    this.$emit('input',this.formulario.terminos);
                    this.$store.commit('setSubActual',1);
                }else{
                    this.$root.$emit('bv::show::modal', 'modal-terminos', '#modal-terminos');
                }
            }
        },
        created(){
            this.generarLogo();
            if(!constantes.funciones.isEmpty(this.$store.getters.getPasos["2"]))
                this.formulario=this.$store.getters.getPasos["2"];
        },
        mounted() {
            this.generarLogo();
        }
    }
</script>

<style scoped>
    .logo-version{
        background-position: center;
        max-width: 40%;
        padding-bottom: 20px;
    }
    .logo-modelo{
        filter: invert(100%);
        background-position: center;
        max-width: 40%;
        padding-bottom: 20px;
    }
    .text-justify-p{
        font-size: 15px;
    }
    .vehiculo{
        position:fixed;
    }
</style>
